import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa'

import {
  Container,
  Row,
  SubTitle,
  InfoText,
  Button
} from './styles'

export default function AccessLevel ({
  index,
  data: accessLevel,
  professionalID = null,
  enableEdit = false,
  professionalPermissions = [],
  style = {},
  onEdit = () => {},
  onDelete: handleDelete = () => {}
}) {
  const [showAlertDialog, setShowAlertDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const { permissions } = accessLevel
  const businessId = AuthService.getBusinessId ()
  const userType = AuthService.getUserType ()
  const business = AuthService.getUser ()
  const token = AuthService.getToken ()
  const isEditable = accessLevel?.business_id === businessId

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const handleEdit = () => onEdit (accessLevel)

  const deleteAccessLevel = async () => {
    setDeleting (true)
    try {
      if (professionalID) {
        await cutileiApi.delete (
          `/businesses/${businessId}/professionals/${professionalID}/access_levels/${accessLevel.id}`,
          requestConfig
        )
      } else {
        await cutileiApi.delete (`/access_levels/${accessLevel.id}`, requestConfig)
      }

      setDeleting (false)
      handleDelete (accessLevel)
    } catch (error) {
      setDeleting (false)
      logApiError (error)
    }
  }

  const toggleAlertDialog = () => setShowAlertDialog (!showAlertDialog)

  return (
    <Container style={style}>
      <SubTitle>
        {accessLevel.name}
        {
          !professionalID &&
          accessLevel.codename === 'administrador' &&
          ['business', 'admin'].includes (userType) && (
            `\n(${business.name})`
          )
        }
      </SubTitle>
      {professionalPermissions ? (
        <InfoText>
          {professionalPermissions.length} {professionalPermissions.length === 1 ? 'Permissão' : 'Permissões'}
        </InfoText>
      ) : (
        <InfoText>
          {permissions.length} {permissions.length === 1 ? 'Permissão' : 'Permissões'}
        </InfoText>
      )}
      <Row style={{justifySelf: 'center'}}>
        <Button onClick={handleEdit}>
          {isEditable && !professionalID || enableEdit ? (
            <FaEdit color='#35A7FF' size={18}/>
          ) : (
            <FaEye color='#35A7FF' size={18}/>
          )}
        </Button>
        {(isEditable || (!!professionalID && index > 0)) && (
          <Button onClick={toggleAlertDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <AlertDialog
        visible={showAlertDialog}
        title='Atenção!'
        message={
          professionalID
            ? 'Deseja realmente remover este nível de acesso deste(a) profissional?'
            : 'Deseja realmente excluir este nível de acesso?'
        }
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteAccessLevel}
        onClose={toggleAlertDialog}
        dangerous
      />
    </Container>
  )
}
